import React from "react";
/* import classes from './Checkmark' */
import CheckIcon from "@mui/icons-material/Check";

const Checkmark = () => {
  return (
    <div className="circle">
      {/* <div className="checkmark"></div> */}
      <CheckIcon sx={{ color: "#fff", fontSize: "3rem" }} />
    </div>
  );
};

export default Checkmark;
